/**
 * Set up routing for all CertificateTemplate views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import certificate-template views
// import CreateCertificateTemplate from './views/CreateCertificateTemplate.js.jsx';
// import CertificateTemplateList from './views/CertificateTemplateList.js.jsx';
// import SingleCertificateTemplate from './views/SingleCertificateTemplate.js.jsx';
// import UpdateCertificateTemplate from './views/UpdateCertificateTemplate.js.jsx';

class CertificateTemplateRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
      {/**
        <Route exact path="/certificate-templates" component={CertificateTemplateList} />
        <YTRoute login={true} exact path="/certificate-templates/new" component={CreateCertificateTemplate} />
        <Route exact path="/certificate-templates/:certificateTemplateId" component={SingleCertificateTemplate}/>
        <YTRoute login={true} exact path="/certificate-templates/:certificateTemplateId/update" component={UpdateCertificateTemplate}/>
      */}
      </Switch>
    )
  }
}

export default CertificateTemplateRouter;



// WEBPACK FOOTER //
// modules/certificateTemplate/CertificateTemplateRouter.js.jsx